'use client';

import { useState } from 'react';
import { Icons } from '../icons';
import { cn } from '#/lib/utils';
import { toast } from 'react-toastify';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '#/components/ui/tooltip';

interface CopyToClipboardProps {
  text: string;
  children?: React.ReactNode;
  className?: string;
  showIcon?: boolean;
  toastMessage?: string;
}

export function CopyToClipboard({
  text,
  children,
  className,
  showIcon = true,
  toastMessage = '이메일 주소가 복사되었습니다.'
}: CopyToClipboardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success(toastMessage);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
      toast.error('복사에 실패했습니다');
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={handleCopy}
          className={cn(
            'inline-flex items-center gap-1 transition-colors',
            className
          )}
          type="button"
        >
          {children || text}
          {showIcon && (
            <span className="ml-1">
              {copied ? (
                <Icons.check className="w-4 h-4 text-green-500" />
              ) : (
                <Icons.copy className="w-4 h-4" />
              )}
            </span>
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{copied ? '복사됨' : '클릭하여 복사'}</p>
      </TooltipContent>
    </Tooltip>
  );
}
